import {
  IGRNSubGRNListResponseData,
  IInventoryPurchaseOrderDraftPropsBody,
  POStatusTypes,
} from "@/api_framework/api_modals/Inventory";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
// import { useGRNCompleteGRNUpdateAPI } from "@/app/hooks/api_hooks/Inventory/PO/useGRNCompleteGRNUpdateAPI";
import { useInventoryPurchaseOrderUpdateAPI } from "@/app/hooks/api_hooks/Inventory/PO/useInventoryPurchaseOrderUpdateAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useLoader } from "@/app/hooks/useLoader";
import { useRouter } from "@/app/hooks/useRouter";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { startCase } from "lodash";
import { useState } from "react";
import { LuLoader2 } from "react-icons/lu";

export interface IPOStatusUpdateModalState {
  prevPOStatus: POStatusTypes;
  nextPOStatus: POStatusTypes;
  POPayload: IInventoryPurchaseOrderDraftPropsBody;
  GRNPayload?: IGRNSubGRNListResponseData[];
  GRNId?: string;
}

const POStatusUpdateModal = () => {
  const { getRouteKey } = useRouter();
  const { nextPOStatus, prevPOStatus, POPayload, GRNId, GRNPayload } = useModalState(
    "PO_STATUS_UPDATE",
  ) as IPOStatusUpdateModalState;
  const { setInvisible } = useModalActions("PO_STATUS_UPDATE");
  const isPOUpdateInProgress = useLoader("isPOStatusUpdateInProgress");
  const updatePOWithNextStatus = useInventoryPurchaseOrderUpdateAPI();
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async () => {
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    const res = await updatePOWithNextStatus(POPayload, POPayload.po_id, nextPOStatus);
    if (res.status) {
      window.open(getRouteKey("PURCHASE_LIST", "url"), "_self");
      setInvisible();
    } else {
      setButtonDisabled(false);
    }
  };

  return (
    <ModalPrompt
      modalId="PO_STATUS_UPDATE"
      title="PO Status Update"
      backdropBlur
      button={{
        primaryButtonText: "Update PO",
        primaryButtonClassname: "bg-blue-500",
        secondaryButtonText: "Cancel",
        primaryCallback: handleSubmit,
        primaryButtonDisabled: isButtonDisabled,
      }}
      content={
        POPayload && (
          <div className="text-xs">
            Are you sure you want to update the current{" "}
            <span>
              Purchase Order <span className="font-semibold">#{POPayload.po_number}</span> from{" "}
              <span className="flex justify-start items-center">
                <span className="font-semibold text-blue-500">{startCase(prevPOStatus.split("_")?.join(" "))}</span>
                <span>
                  <ArrowRightIcon className="w-4 h-4" />
                </span>{" "}
                <span className="font-semibold text-orange-500">{startCase(nextPOStatus.split("_")?.join(" "))}</span>
              </span>{" "}
            </span>
            {GRNId && (
              <div className="mt-4 text-xs">
                <p>The following goods will be marked done and available for inventory.</p>
                <ol className="mt-2 list-decimal">
                  {GRNPayload?.map((subGRN) => {
                    return subGRN?.completed_grn?.map((product) => {
                      return (
                        <li className="font-semibold" key={product.variant_id}>
                          {product.variant_name}
                        </li>
                      );
                    });
                  })}
                </ol>
              </div>
            )}
            {(isPOUpdateInProgress || isButtonDisabled) && (
              <div className="mt-6">
                <p className="flex justify-start items-center gap-x-3 bg-green-50 p-2 rounded-md text-green-600 text-xs">
                  {" "}
                  <LuLoader2 className="animate-spin" /> Updating ...{" "}
                </p>
              </div>
            )}
          </div>
        )
      }
    />
  );
};

export default POStatusUpdateModal;
